import { useEffect } from "react";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import Lenis from "lenis";
import "@/App.css";
import { EnquiryProvider } from "@/context/EnquiryContext";
import { Nav } from "@/components/Nav";
import { Footer } from "@/components/Footer";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import { EnquiryModal } from "@/components/EnquiryModal";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import Industries from "@/pages/Industries";
import Brands from "@/pages/Brands";
import Clients from "@/pages/Clients";
import Contact from "@/pages/Contact";
import Admin from "@/pages/Admin";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
};

const useLenis = () => {
  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return undefined;
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);
};

function App() {
  useLenis();

  return (
    <div className="App grain">
      <BrowserRouter>
        <EnquiryProvider>
          <ScrollManager />
          <Nav />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/products" element={<Products />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/brands" element={<Brands />} />
            <Route path="/clients" element={<Clients />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
          <Footer />
          <WhatsAppFloat />
          <EnquiryModal />
        </EnquiryProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
